// @/Components/Modals/ActiveMeetingsModal.tsx
import React from 'react';
import {View, Modal, TouchableOpacity, StyleSheet} from 'react-native';
import Icon from 'react-native-vector-icons/MaterialIcons';
import CCText from '@/Atoms/CCText';
import CCButton from '@/Atoms/CCButton/CCButton';
import CCColors from '@/Utils/CCColors';
import {FontSizes} from '@/Utils/Dimensions';

interface ActiveMeetingsModalProps {
  visible: boolean;
  activeMeetingsCount: number;
  onClose: () => void;
  onJoin: () => void;
  onEndAndJoin: () => void;
}

export const ActiveMeetingsModal: React.FC<ActiveMeetingsModalProps> = ({
  visible,
  activeMeetingsCount,
  onClose,
  onJoin,
  onEndAndJoin,
}) => {
  return (
    <Modal
      animationType="slide"
      transparent={true}
      visible={visible}
      onRequestClose={onClose}>
      <View style={styles.modalOverlay}>
        <View style={styles.modalContent}>
          <View style={styles.modalHeader}>
            <View style={{flex: 1}}>
              <CCText fontWeight="bold" fontSize={FontSizes[16]}>
                Active Meetings Detected
              </CCText>
            </View>
            <TouchableOpacity onPress={onClose} style={styles.closeButton}>
              <CCText style={styles.closeButtonText}>×</CCText>
            </TouchableOpacity>
          </View>

          <View style={styles.modalBody}>
            <Icon
              name="info-outline"
              size={60}
              color={CCColors.Primary.Dark}
              style={{alignSelf: 'center', marginVertical: 20}}
            />
            <CCText
              fontSize={FontSizes[16]}
              color={CCColors.Black}
              style={{textAlign: 'center', marginBottom: 10}}>
              You have {activeMeetingsCount} active meeting
              {activeMeetingsCount > 1 ? 's' : ''} running.
            </CCText>
            <CCText
              fontSize={FontSizes[14]}
              color={CCColors.Grey.Grey}
              style={{textAlign: 'center', marginBottom: 20}}>
              Would you like to end the active meeting
              {activeMeetingsCount > 1 ? 's' : ''} before joining, or join
              directly?
            </CCText>

            <View style={styles.buttonContainer}>
              <CCButton
                style={styles.actionButton}
                hoverEffect={false}
                onPress={onEndAndJoin}>
                <CCText color={CCColors.Black} fontWeight="medium">
                  End & Join
                </CCText>
              </CCButton>

              <CCButton
                style={[styles.actionButton, styles.secondaryButton]}
                hoverEffect={false}
                onPress={onJoin}>
                <CCText color={CCColors.Primary.Dark} fontWeight="medium">
                  Join Anyway
                </CCText>
              </CCButton>
            </View>
          </View>
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  modalOverlay: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalContent: {
    width: '90%',
    maxWidth: 500,
    backgroundColor: '#fff',
    padding: 24,
    borderRadius: 10,
    elevation: 10,
  },
  modalHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 16,
  },
  closeButton: {
    padding: 4,
  },
  closeButtonText: {
    fontSize: 32,
    fontWeight: 'bold',
    color: CCColors.Grey.Grey,
    lineHeight: 32,
  },
  modalBody: {
    alignItems: 'center',
  },
  buttonContainer: {
    width: '100%',
    gap: 12,
    marginTop: 10,
  },
  actionButton: {
    paddingHorizontal: 20,
    paddingVertical: 12,
    borderRadius: 8,
    width: '100%',
  },
  secondaryButton: {
    backgroundColor: CCColors.White,
    borderWidth: 1,
    borderColor: CCColors.Primary.Dark,
  },
});
